import { Result, failure, success } from '../shared'
import { LogsProvider } from './logs.provider'
import { LogsServiceErrorCode, LogsServerData, LogsRequestAttributes, GetLogsFailure } from './logs.types'

export class LogsService {
  constructor(private provider: LogsProvider) {}

  public async get(attributes: LogsRequestAttributes): Promise<Result<LogsServerData, GetLogsFailure>> {
    try {
      const { data } = await this.provider.get(attributes)
      return success(data)
    } catch (error) {
      return failure(LogsServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async lookups(): Promise<Result<string[]>> {
    try {
      const { data } = await this.provider.lookups()
      return success(data.Apps.map((item) => item.App))
    } catch (error) {
      return failure(LogsServiceErrorCode.GENERAL)
    }
  }
}
